import React, {useState, useEffect} from 'react';
import {path} from 'ramda';
import {getDynamicFormContext, getDynamicFormCategories} from "../../../shared/requests-api";
import {$} from "../../../shared/utils";
import {Button} from '@maxmilhas/hangar-components-atomic/public';
import RebookingModal from './RebookingModal';
import DynamicForm from '../../DynamicForm';
import ModalError from '../../DynamicForm/components/ModalError';
import FlightResume from '../FlightResume';
import CancellationModal from '../cancellation/CancellationModal';
import CreditResume from './CreditResume';

export const RebookingCard = React.forwardRef(({trip, token, isSelected}, ref) => {
  const [actionLoading, setActionLoading] = useState(false);
  const [contextualSearchModal, setContextualSearchModal] = useState({open: false, trip: null});
  const [dynamicModal, setDynamicModal] = useState({
    open: false,
    ruleId: null,
    title: null,
    contextToken: null,
    correlationId: null
  });
  const [errorModal, setErrorModal] = useState({open: false, scenario: null, correlationId: null});

  const handleModal = (status, trip = null) => {
    setContextualSearchModal({open: status, tripId: trip ? trip.order.code : null});
  };

  const handleRebooking = async trip => {
    setActionLoading(true);

    try {
      const context = await getDynamicFormContext(token, {
        name: "contexto-remarcacao-com-credito",
        data: {
          providerOrderId: trip.order.code
        }
      });

      const _categories = await getDynamicFormCategories(token, context.data.contextToken, context.headers['x-correlation-id']);

      if (_categories.data.length > 0) {
        setDynamicModal({
          open: true,
          title: _categories.data[0].rules[0].name,
          ruleId: _categories.data[0].rules[0].id,
          contextToken: context.data.contextToken,
          correlationId: context.headers['x-correlation-id']
        });
      } else {
        handleModal(true, trip);
      }
    } catch (err) {
      if (err.response.status === 400 || err.response.data.type == "ExistingCancellationRequestException") {
        openCancellationModal(err.response.data);
      } else {
        setErrorModal({
          open: true,
          scenario: null,
          correlationId: path(['response', 'headers', 'x-correlation-id'], err),
          messages: err.response.data.message ? JSON.parse(err.response.data.message) : null,
        });
      }
    } finally {
      setActionLoading(false);
    }
  };

  /** Triggers do modal de cancelamento na tela **/
  const openCancellationModal = (scenario) => {
    $("body").classList.add("body-lock");

    if (scenario.purchase) {
      scenario.order = trip;
    } else if (scenario.type == "ExistingCancellationRequestException") {
      const ticketId = scenario.message.search("ticketId");
      const transactionId = scenario.message.search("transactionId");

      scenario.ticketId = scenario.message.slice(ticketId, transactionId).replace(/\D/g, '');
      scenario.transactionId = scenario.message.slice(transactionId).replace(/\D/g, '');
      scenario.order = trip;
    }

    setErrorModal({open: true, correlationId: null, scenario});
  };

  const closeCancellationModal = () => {
    $("body").classList.remove("body-lock");
    setErrorModal({...errorModal, open: false});
  };

  useEffect(() => {
    if (isSelected) {
      handleRebooking(trip);
    }
  }, []);

  return (
    <>
      <div ref={ref} id={trip.order.code} style={{marginTop: -75, paddingTop: 75}}/>

      <article className="new-card">
        <div className="new-card__content">
          <div className="row">
            <div className="col-xs-16">
              <div className="order-status">
                <span className="highlight-strong">
                  Compra <strong>{trip.order.code}</strong>
                </span>
              </div>
              <hr/>
              <div>
                <CreditResume
                  contextualRebooking={trip.contextualRebooking}
                />
              </div>
              <div className="my-trips-light-flight-wrapper">
                <div className="col-md-8">
                  <FlightResume
                    flights={trip.flights}
                    passengers={trip.passengers}
                  />
                </div>
                <div className="col-md-5 col-md-offset-3 col-lg-4 col-lg-offset-4">
                  <div className="order-actions">
                    <Button
                      disabled={actionLoading}
                      size="small"
                      onClick={() => handleRebooking(trip)}
                    >
                      {actionLoading ? (
                        <i className="loader loader-fetching center-block"/>
                      ) : 'Usar crédito'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {contextualSearchModal.open && (
          <RebookingModal
            open={contextualSearchModal.open}
            token={token}
            tripId={contextualSearchModal.tripId}
            onClose={flag => handleModal(flag)}
          />
        )}

        {dynamicModal.open && (
          <DynamicForm
            open={dynamicModal.open}
            title={dynamicModal.title}
            ruleId={dynamicModal.ruleId}
            contextToken={dynamicModal.contextToken}
            correlationId={dynamicModal.correlationId}
            onClose={() => setDynamicModal({...dynamicModal, open: false})}
          />
        )}

        {(errorModal.open && errorModal.scenario) && (
          <div
            className={`cancellation-modal tingle-modal ${errorModal.open ? "tingle-modal--visible" : ""}`}>
            <CancellationModal
              open={errorModal.open}
              scenario={errorModal.scenario}
              closeModal={closeCancellationModal}
              btnAction={closeCancellationModal}
            />
          </div>
        )}

        {(errorModal.open && !errorModal.scenario) && (
          <ModalError
            open={errorModal.open}
            onClose={() => setErrorModal({...errorModal, open: false})}
            correlationId={errorModal.correlationId}
            messages={errorModal.messages}
          />
        )}
      </article>
    </>
  );
});

export default RebookingCard;
